import { api } from '@/api/client';

export interface AdminActivityEntry {
  type: 'request' | 'action' | 'error';
  ts: string;
  // Request fields
  method?: string;
  path?: string;
  query?: string;
  status?: number;
  duration?: number;
  ip?: string;
  // Action fields
  action?: string;
  detail?: string;
  module?: string;
  taskId?: number;
  meta?: Record<string, unknown>;
  // Error fields
  level?: 'warn' | 'error' | 'fatal';
  msg?: string;
  stack?: string;
  reqId?: string;
  // Common
  userId: string;
  userName: string;
  roles: string[];
}

export interface AdminActivityParams {
  limit?: number;
  type?: 'requests' | 'actions' | 'errors' | 'all';
  method?: string;
  user?: string;
  statusClass?: '4xx' | '5xx';
  status?: number;
  from?: string;
  to?: string;
}

export async function fetchAdminActivity(params: AdminActivityParams = {}): Promise<{
  entries: AdminActivityEntry[];
  total: number;
  requestCount: number;
  actionCount: number;
  errorCount: number;
}> {
  const query = new URLSearchParams();
  if (params.limit) query.set('limit', String(params.limit));
  if (params.type) query.set('type', params.type);
  if (params.method) query.set('method', params.method);
  if (params.user) query.set('user', params.user);
  if (params.statusClass) query.set('statusClass', params.statusClass);
  if (params.status) query.set('status', String(params.status));
  if (params.from) query.set('from', params.from);
  if (params.to) query.set('to', params.to);
  const qs = query.toString();
  return api(`/api/admin/activity${qs ? `?${qs}` : ''}`);
}
